var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrowsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.668 10.1667L9.66797 7V13.3333L13.668 10.1667Z",
    fill: "#0F5BF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 9H10.7034V11.3333H0.332031V9ZM0.332031 3.16667L4.33203 0V6.33333L0.332031 3.16667Z",
    fill: "#0F5BF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29688 2H13.6682V4.33333H3.29688V2Z",
    fill: "#0F5BF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowsIcon);
export default __webpack_public_path__ + "static/media/DoubleArrowsIcon.ecb0ab4769f4d45620c00f89cf1b873e.svg";
export { ForwardRef as ReactComponent };